
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, Tab, Tabs } from "@mui/material";

import { TabPanel, TabProps } from "../../../helpers/TabPanel";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout";
import { InfoField } from "../../../components/InfoField";
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";
import { BoxInformacionExhortoRecibido } from "../../../components/BoxInformacionExhortoRecibido";

import { defaultExhortoLibrado, ExhortoLibradoProps } from "../../../interfaces/tribunal/ExhortoLibradoInterface";

import { ActualizarEstatus, DetalleExhortoLibrado } from "../../../connections/tribunal/ExhortoLibradoConnection";

export const VisualizarExhortoLibradoPage = () => {

    const { Id } = useParams();

    const dispatch = useDispatch();

    const [value, setValue] = useState( 0 );

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [exhortoLibrado, setExhortoLibrado] = useState<ExhortoLibradoProps>( defaultExhortoLibrado );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const handleChange = (_: React.SyntheticEvent, newValue: number) => setValue( newValue );

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        await ActualizarEstatus({ idExhortoLibrado: Id ?? '', idEstatus: 3, observacion: '' }).then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                    setProcesoTerminado( true );
                    setLoadingFinalizar( false );

                }
                else {

                    setTimeout(() => {

                        dispatch(openSnackbar({ message: message, variant: 'error' }));
                        setLoadingFinalizar( false );

                    }, 700);

                }

            }, 700);

        });

    }

    useEffect(() => {

        setLoading( true );

        async function Obtener() {

            await DetalleExhortoLibrado( Id ?? '' ).then( resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setExhortoLibrado( resp );

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${resp.nombreUsuarioAsignado}`);
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 48 ) {
                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 48 ) {
                            setLoading( false );
                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        Obtener();

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Exhorto librado' }, { text: 'Visualizar exhorto librado' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                ?
                    procesoNoEncontrado
                    ?
                        <BoxProcesoNoEncontrado />
                    :
                        procesoCancelado
                        ?
                            <BoxProcesoCancelado />
                        :
                            <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ exhortoLibrado?.idEstatus === 3 } />
                :
                    loading
                    ?
                        <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                            <CircularProgressIndicator />
                        </Box>
                    :
                        <>

                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                <Tabs value={ value } onChange={ handleChange }>

                                    <Tab label="Exhorto librado" {...TabProps( 0 )} />

                                    <Tab
                                        label="Información del expediente"
                                        sx={{ display: exhortoLibrado.idExpediente !== 0 ? 'flex' : 'none' }}
                                        {...TabProps( 1 )}
                                    />

                                    <Tab
                                        label="Información del exhorto"
                                        sx={{ display: exhortoLibrado.idExhortoRecibido !== 0 ? 'flex' : 'none' }}
                                        {...TabProps( 2 )}
                                    />

                                </Tabs>

                            </Box>

                            <TabPanel value={ value } index={ 0 }>

                                <Box p={ 4 } component={ Paper }>

                                    <BoxHeaderInformacion
                                        numeroSeguimiento={ `GEXL-${ exhortoLibrado.idExhortoLibrado }` }
                                        fecha={ exhortoLibrado.fecha ?? new Date() }
                                        juez={ exhortoLibrado.juez }
                                        numeroExhorto={ exhortoLibrado.numeroExhorto }
                                    />

                                    <Grid container spacing={ 3 } mt={ 2 }>

                                        <Grid size={{ md: exhortoLibrado?.dirigidoJuzgadoEstado ? 4 : 12, xs: 12 }}>

                                            <InfoField
                                                chip
                                                label="¿El exhorto librado se dirige a un juzgado perteneciente al Poder Judicial del Estado?"
                                                value={ exhortoLibrado?.dirigidoJuzgadoEstado ? "Sí" : "No" }
                                            />

                                        </Grid>

                                        {
                                            exhortoLibrado?.dirigidoJuzgadoEstado
                                            &&
                                                <Grid size={{ md: 4, xs: 12 }}>

                                                    <InfoField
                                                        chip
                                                        label="Distrito judicial donde se dirige el exhorto librado"
                                                        value={ exhortoLibrado?.distritoJudicial }
                                                    />

                                                </Grid>
                                        }

                                        <Grid size={{ md: 4, xs: 12 }}>

                                            <InfoField
                                                chip
                                                label="Objeto del exhorto"
                                                value={ exhortoLibrado?.objetoExhorto }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 4, xs: 12 }}>

                                            <InfoField
                                                chip
                                                label="Clase del exhorto"
                                                value={ exhortoLibrado?.claseExhorto }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <iframe
                                                title='iframe-documento'
                                                style={{ width: '100%', height: 800, borderRadius: 8 }}
                                                src={ exhortoLibrado?.documento }
                                            />

                                        </Grid>

                                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                            <Grid container spacing={ 3 }>

                                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left' }}> </Grid>

                                                <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'center' }}>

                                                    <Button
                                                        fullWidth
                                                        color='primary'
                                                        variant="contained"
                                                        onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                    >
                                                        Finalizar
                                                    </Button>

                                                </Grid>

                                                <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}> </Grid>

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Box>

                            </TabPanel>

                            <TabPanel value={ value } index={ 1 }>

                                <BoxInformacionExpediente
                                    expediente={ exhortoLibrado.expediente }
                                />

                            </TabPanel>

                            <TabPanel value={ value } index={ 2 }>

                                <BoxInformacionExhortoRecibido
                                    exhortoRecibido={ exhortoLibrado.exhortoRecibido }
                                />

                            </TabPanel>

                            <Dialog
                                fullWidth
                                maxWidth='xs'
                                open={ openDialogConfirmacionFinalizar }
                                onClose={ () => {} }
                            >

                                <DialogTitle>
                                    Confirmación
                                </DialogTitle>

                                <DialogContent sx={ DialogContentStyle }>

                                    <DialogContentText>
                                        ¿Desea finalizar la visualizacion del exhorto librado?
                                    </DialogContentText>

                                </DialogContent>

                                <DialogActions sx={ DialogActionsStyle }>
                                    <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                                    <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>
                                </DialogActions>

                            </Dialog>

                        </>
            }

        </Layout>
    )
}
